<template>
    <div class="banks-list">
        <div class="banks-list__container">
            <h2 class="banks-list__title" v-text="$ml.get('pixTypeFilterBank')" tabindex="0" />
            <BankFilter @filter="updateFilterQuery" />
            <h2 class="banks-list__subtitle" v-text="$ml.get('pixTypeSuggestions')" tabindex="0" />
            <div v-if="loading" class="banks-list__loading-container">
                <img class="banks-list__loading-image" src="@/assets/img/loading.svg" alt="Redirecionamento Openfinance" tabindex="-1" />
                <span class="banks-list__loading-text" v-text="$ml.get('pixOpenFinanceLoadingBanks')" tabindex="0" />
            </div>
            <div v-else-if="filteredBanks.length > 0">
                <BankList :banks="filteredBanks" @select-bank="handleBankSelection" />
            </div>
            <div v-else class="banks-list__error">
                <h2 class="banks-list__title" v-text="$ml.get('pixTypeEmptySearchTitle')" tabindex="0" />
                <p class="banks-list__errorDescription" v-text="$ml.get('pixTypeEmptySearch')" tabindex="0" />
            </div>
        </div>
        <CieloButtonV2 @click="goToPreviousPage" :transparent="true">
            <span :style="{ 'font-weight': 600 }" v-text="$ml.get('back')" tabindex="0" />
        </CieloButtonV2>
    </div>
</template>

<script>
    const CieloButtonV2 = () => import(
        /* webpackChunkName: "cielo-button" */ '@/components/template/CieloButtonV2'
    );
import { mapState, mapGetters, mapActions } from 'vuex';
import { logEvent } from '@/helpers/cieloLogger';
import BankFilter from '@/components/BankFilter';
import BankList from '@/components/BankList';
import banks from '@/mockedBanks';

  export default {
	components: {
		CieloButtonV2,
		BankFilter,
		BankList
	},

	data() {
		return {
			filteredBanks: [],
			banks,
			filterQuery: '',
			loading: true,
		};
	},

	mounted() {
		this.$store.commit('pixOpenFinancePayment/resetSelectedBank');
	},

	computed: {
		...mapState('pixOpenFinancePayment', {
            institutions: state => state.institutions
        }),

		...mapGetters({
            availablePixTypes: 'paymentTypes/getPixTypes',
        }),
	},

	methods: {
		...mapActions('pixOpenFinancePayment', ['fetchInstitutions']),

		updateFilterQuery(query) {
			this.filterQuery = query;
			this.filteredBanks = this.institutions.filter(bank =>
				bank.customerFriendlyName.toLowerCase().includes(this.filterQuery.toLowerCase())
			);
		},

		handleBankSelection(bank) {
			logEvent({
				category: 'itp',
				action: 'selecao_banco_itp',
				label: `customerFriendlyName: ${bank.customerFriendlyName}`
			});

			this.$store.commit('pixOpenFinancePayment/setSelectedBank', bank);
			this.$store.dispatch('pipelineV2/pushTo', 'PersonalData');
		},

		goToPreviousPage() {
			if(this.availablePixTypes.length > 1) {
				this.$store.dispatch('pipelineV2/pushTo', 'ChangePixType');
			} else {
				this.$store.dispatch('pipelineV2/pushTo', 'ChangePaymentType');
			}
		},
	},
	created() {
        this.fetchInstitutions().then(() => {
			this.filteredBanks = this.institutions;
			this.loading = false;
        });
    }
  };
</script>

<style scoped lang="scss">
  .banks-list {
	  @media screen and (max-width: 1024px) {
		  display: flex;
		  flex-direction: column;
		  flex: 1 0 auto;
	  }
	&__container {
		flex: 1;
	}
	&__title {
		display: block;
		font-weight: 700;
		font-size: 16px;
		line-height: 24px;
		color: #2F363E;
		margin-bottom: 20px;
	}

	&__subtitle {
		display: block;
		font-weight: 600;
		font-size: 16px;
		line-height: 24px;
		color: #2F363E;
		margin-bottom: 8px;
	}
	&__errorDescription {
		width: 100%;
		max-width: 580px;
		font-size: 16px;
		font-weight: 500;
		line-height: 24px;
		color: #5C6A7B;
	}
	&__loading-container {
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	&__loading-image {
		width: 24px;
		height: 24px;
		animation: spin 1s linear infinite;
	}
	&__loading-text {
		font-size: 16px;
		font-weight: 500;
		line-height: 24px;
		color: #5C6A7B;
		margin-top: 16px;
	}
  }

  @keyframes spin {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
  }
</style>
